import { render, staticRenderFns } from "./Help-Budget.vue?vue&type=template&id=00980a16&scoped=true&"
import script from "./Help-Budget.vue?vue&type=script&lang=js&"
export * from "./Help-Budget.vue?vue&type=script&lang=js&"
import style0 from "./Help-Budget.vue?vue&type=style&index=0&id=00980a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00980a16",
  null
  
)

export default component.exports